import { Button, FormControl, InputLabel, MenuItem, Select, Stack, TextField } from '@mui/material'
import { DatePicker } from '@mui/x-date-pickers-pro'
import { Controller, useForm, useWatch } from 'react-hook-form'
import { DiscountModifier } from '../../api/api'

export interface PerUnitDiscountComponentProps {
  onCreatePerUnitDiscount: (data: PerUnitDiscountForm) => void
  currency: string
  isPatching: boolean
}

export interface PerUnitDiscountForm {
  discountModifier: DiscountModifier
  discountValue: number
  expirationDate: Date | undefined
}

export const PerUnitDiscountComponent = ({ onCreatePerUnitDiscount, currency, isPatching }: PerUnitDiscountComponentProps) => {
  const form = useForm<PerUnitDiscountForm>({
    defaultValues: {
      discountModifier: DiscountModifier.ABSOLUTE,
      discountValue: 0,
      expirationDate: undefined,
    },
  })

  const discountType = useWatch({ control: form.control, name: 'discountModifier' })

  const discountEndAdornment = discountType === DiscountModifier.ABSOLUTE ? currency : '%'

  return (
    <>
      <Stack
        direction="row"
        sx={{
          gap: 2,
        }}
      >
        <FormControl fullWidth>
          <InputLabel>Discount type</InputLabel>
          <Controller
            control={form.control}
            name="discountModifier"
            render={({ field }) => (
              <Select
                label="Discount type"
                slotProps={{ input: { 'aria-label': 'discount-modifier' } }}
                onChange={(a) => field.onChange(a.target.value as PerUnitDiscountForm['discountModifier'])}
                value={field.value}
              >
                <MenuItem value={DiscountModifier.ABSOLUTE}>Fixed</MenuItem>
                <MenuItem value={DiscountModifier.PERCENTAGE}>Percentage</MenuItem>
              </Select>
            )}
          />
        </FormControl>
        <TextField
          slotProps={{ input: { endAdornment: discountEndAdornment }, htmlInput: { 'aria-label': 'discount-value' } }}
          label="Discount value"
          type="number"
          {...form.register('discountValue', { valueAsNumber: true })}
          error={Boolean(form.formState.errors.discountValue)}
          helperText={form.formState.errors.discountValue?.message}
        />
      </Stack>
      <DatePicker
        slotProps={{ textField: { 'aria-label': 'discount-expiration-date' } }}
        label="Expiration date"
        onChange={(date) => form.setValue('expirationDate', date?.toDate())}
      />
      <Button loading={isPatching} onClick={form.handleSubmit((data) => onCreatePerUnitDiscount(data))} variant="contained">
        Create Discount
      </Button>
    </>
  )
}
